import * as yup from "yup";

export const basicSchema = yup.object().shape({
  name: yup.string()
  .required("Name required"),
  surname: yup.string()
  .required("Surname required"),
  street: yup.string()
    .required("Street required"),
  region: yup.string()
    .required("Region required"),
  country: yup.string()
    .required("Country required"),
  city: yup
    .string()
    .required("City required"),
  zipcode: yup
    .number("Zipcode must be a number")
    .required("Zipcode required"),
  countryCode: yup.string()
    .required("Country code is required")
});